import type { components } from '../api/shema';
import type { Pravice } from './seja';
import { useSeja } from './useSeja';

/** Področje pravic (široko: računi, vozila, nabavne cene …) in raven na njem – kot {@code Podrocje}/{@code Raven} na strežniku. */
export type Podrocje = NonNullable<components['schemas']['PodrocjePravic']['podrocje']>;
export type Raven = NonNullable<Pravice[keyof Pravice]>;

const RED: Record<Raven, number> = { BREZ: 0, PREGLED: 1, UREJANJE: 2 };

/** Imena področij pravic za sporočila (kot {@code Podrocje.naziv} na strežniku). */
export const NAZIVI_PODROCIJ: Record<Podrocje, string> = {
  RACUNI: 'Računi',
  PREDRACUNI: 'Predračuni',
  VOZILA: 'Vozila in zaloga',
  NABAVNE_CENE: 'Nabavne cene in stroški',
  STRANKE: 'Stranke',
  DELAVNICA: 'Delavnica',
  ANALIZE: 'Analize in poročila',
  PONUDBA: 'Javna ponudba in povpraševanja',
  NASTAVITVE: 'Nastavitve podjetja',
  UPORABNIKI: 'Uporabniki in vloge',
  NAROCNINA: 'Naročnina in umetna inteligenca',
};

/** Nazivi ravni za uporabnike. */
export const NAZIVI_RAVNI: Record<Raven, string> = { BREZ: 'Brez', PREGLED: 'Pregled', UREJANJE: 'Urejanje' };

/**
 * Ali pravice zadoščajo za raven na področju (urejanje vključuje pregled). Brez podatka o pravicah (starejši strežnik)
 * da – omejitve vedno preveri strežnik, splet samo skrije, česar uporabnik ne sme.
 */
export function sme(pravice: Pravice | undefined, podrocje: Podrocje, raven: Raven = 'PREGLED'): boolean {
  if (!pravice) {
    return true;
  }
  return RED[pravice[podrocje] ?? 'BREZ'] >= RED[raven];
}

/** Ali sme prijavljeni uporabnik to raven na področju (dokler seja ni naložena: da). */
export function usePravica(podrocje: Podrocje, raven: Raven = 'PREGLED'): boolean {
  const stanje = useSeja();
  return stanje.status !== 'prijavljen' || sme(stanje.pravice, podrocje, raven);
}

/** Pravice prijavljenega uporabnika ({@code undefined} = vse, glej {@link sme}). */
export function usePravice(): Pravice | undefined {
  const stanje = useSeja();
  return stanje.status === 'prijavljen' ? stanje.pravice : undefined;
}
